<p-toast [preventDuplicates]="true" [preventOpenDuplicates]="true"/>
<p-divider/>
<div class="" *ngFor="let prj of tramiteService.proyectoAsignado()">
    <div class="card h-full">
        <div class="flex flex-column md:flex-row justify-content-between align-items-center mb-4">
            <div class="flex flex-column text-center md:text-left">
                <span class="text-700 text-2xl mb-2 font-bold">Proyecto: {{ tramiteService.proyectoAsignado()[0].nombre }}</span>
                <span class="text-700 text-lg">{{ tramiteService.proyectoAsignado()[0].descripcion }}</span>
            </div>
            <div class="p-toolbar-group-end">
                        <span class="p-2">
                               <p-button
                                   (click)="goBack()"
                                   label="Regresar"
                                   icon="pi pi-undo text-2xl"
                                   styleClass="p-button-rounded ml-2"/>
                        </span>
            </div>
        </div>
        <p-tabView>
            <p-tabPanel>
                <ng-template pTemplate="header">
                    <i class="pi pi-book"></i>
                    <span class="pl-1">Generales</span>
                </ng-template>
                <app-generales-proyecto [rendertitle]="true" [prj]="prj"
                ></app-generales-proyecto>
            </p-tabPanel>
        </p-tabView>
    </div>
</div>
<p-divider/>
<shared-loader class="global-overlay" [hidden]="!_showLoader"></shared-loader>
<p-card *ngIf="this.selected!==null"
        [header]="esConstruccion()!=null?!esConstruccion()?this.selected.nombreTramite + ' - URBANIZACION':this.selected.nombreTramite:''">
    <div>
        <p-panel [collapsed]="false" header="Generalidades del terreno" [toggleable]="true"
                 *ngIf="!this.tramiteService.areasGeneralidadesTerrenoCompletadas()">
            <div class="text-900 font-semibold text-xl">Área del terreno</div>
            <div class="p-fluid p-formgrid grid mt-2">
                <div class="field col-12 md:col-3" *ngFor="let areasGenerales of formAreasGenerales(); let i = index">
                    <span class="p-float-label p-input-icon-right">
                        <i *ngIf="esValidaAreas && areasGenerales.area!>=0"
                           class="pi pi-check" [style]="{'font-size':'1rem', 'color':'green !important'}"></i>
                        <i *ngIf="!esValidaAreas" class="pi pi-ban"
                           [style]="{'font-size':'1rem', 'color':'red !important'}"></i>
                        <input [(ngModel)]="areasGenerales.area!" id="areaGenerales-{{i}}" type="number"
                               #areaGeneralesInput="ngModel" required pInputText
                               pattern="(0(\.0+)?|[1-9][0-9]*(\.[0-9]+)?)"
                               [min]="0" pTooltip="Área debe ser menor que área total"
                               (input)="isAreasGeneralesValidar()" (keydown)="isNumericValidAreas($event)" (blur)="onChangeArea($event,areasGenerales)"
                               [ngClass]="{'ng-invalid ng-dirty' : (areasGenerales.area==null||areasGenerales.area!<0)}"
                               [disabled]="areasGenerales.idTipoArea===1"/>
                        <label for="areaGenerales-{{i}}" class="mb-2">{{areasGenerales.tipoArea }}<small style="color:black"><b> m²</b></small>
                            <small style="color:red"><b> *</b></small></label>
                    </span>
                    <small *ngIf="(areasGenerales.area === 0 || areasGenerales.area === null) && areasGenerales.idTipoArea==1" style="color:red">
                        <b>Favor ingresar el área total</b>
                    </small>
                    <small *ngIf="!esValidaAreas && areasGenerales.idTipoArea!==1" style="color:red"><b>El área es inválida</b></small>
                </div>
            </div>
            <div class="text-900 font-semibold text-lg -mt-5 mb-5">
                <small style="color:red" class="ng-dirty ng-invalid" *ngIf="!esValidaAreas"><b>Áreas a desarrollar e impermeabilizar inválidas</b></small>
            </div>
            <div>
                <ng-container>
                    <div class="mt-5">
                        <div class="text-900 font-semibold text-xl">
                            Áreas estimadas del proyecto de {{ esConstruccion() ? 'construcción' : 'urbanización' }}
                        </div>
                        <div class="p-fluid p-formgrid grid mt-2">
                            <div class="field col-12 md:col-4" *ngFor="let area of formAreas(), let i = index">
                                <span class="p-float-label p-input-icon-right">
                                     <i *ngIf="area.area!==null && area.area!==0 && !isValidarAreas(esConstruccion())"
                                        class="pi pi-check"
                                        [style]="{'font-size':'1rem', 'color':'green !important'}"></i>
                                    <i *ngIf="isValidarAreas(esConstruccion()) && area.area!=0" class="pi pi-ban"
                                       [style]="{'font-size':'1rem', 'color':'red !important'}"></i>
                                    <input [(ngModel)]="area.area!" id="areas" type="number"
                                           #areasInput="ngModel" required pInputText
                                           pTooltip="La suma de las áreas no debe ser mayor al área total"
                                           [min]="0" (keydown)="isNumericValidAreas($event)" (blur)="onChangeAreasEstimadas($event,area)"
                                           [ngClass]="{'ng-invalid ng-dirty' : area.idTipoArea==2? !tramiteCompleto && (area.area==null||area.area===0) && esConstruccion():
                                           (area.area==null||area.area===0) && !esConstruccion()}"/>
                                         <label for="areas" class="mb-2">
                                            {{ area.tipoArea }}
                                            <small [style]="{'color': (area.area == null || area.area < 0) ? 'red' : 'black'}"><b> m²</b></small>
                                            <small style="color:red"><b> *</b></small>
                                            <span *ngIf="esConstruccion()">{{ calcularPorcentajeTotal(area.area!) }}</span>
                                            </label>
                                </span>
                            </div>
                        </div>
                        <div class="text-900 font-semibold text-lg -mt-5 mb-5">
                            <small style="color:red" class="ng-dirty ng-invalid" *ngIf="isValidarAreas(esConstruccion())"><b>La
                                suma de las áreas no debe ser mayor al área total</b>
                            </small>
                        </div>
                    </div>
                </ng-container>
            </div>
            <div>
                <ng-container *ngIf="!esConstruccion(); else elseForm">
                    <div class="text-900 font-semibold text-xl mb-3">Lotes a urbanizar</div>
                    <div class="p-fluid p-formgrid grid mt-2">
                        <div class="field col-12 md:col-3">
                                <span class="p-float-label">
                                    <input [(ngModel)]="cantidadLotes" id="cantidadLotes" type="number"
                                           #cantidadLotesInput="ngModel" required pInputText
                                           pTooltip="Cantidad lotes"
                                           [ngClass]="{'ng-invalid ng-dirty' : !tramiteCompleto && (cantidadLotes==null||cantidadLotes==0) && !esConstruccion()}"
                                           [min]="1"/>
                                    <small style="color:red" class="ng-dirty ng-invalid"
                                           *ngIf="!tramiteCompleto && (cantidadLotes==null||cantidadLotes==0)"><b>Favor ingresar una
                            cantidad de lotes correcta</b></small>
                                </span>
                        </div>

                        <div class="field col-12 md:col-3">
                            <p-dropdown #dropPrueba [ngModel]="localizacionSeleccionada()"
                                        (onChange)="setLocalizacion($event.value)" id="localizacion"
                                        [options]="listaLocalizacion" optionLabel="descripcion" [showClear]="true"
                                        placeholder="Localización *" [required]="true"
                                        [ngClass]="{'ng-invalid ng-dirty' : !tramiteCompleto && !localizacionSeleccionada()}"></p-dropdown>
                            <small style="color:red" class="ng-dirty ng-invalid"
                                   *ngIf="!tramiteCompleto && !localizacionSeleccionada()"><b>Favor
                                seleccione el grado de localización</b></small>
                        </div>
                        <div class="field col-12 md:col-3">
                            <p-dropdown #dropPrueba [ngModel]="densidadSeleccionada()"
                                        (onChange)="setDensidad($event.value)" id="densidad" [options]="listaDensidad"
                                        optionLabel="descripcion" [showClear]="true"
                                        placeholder="Densidad (en área de lotes) *"
                                        [required]="true"
                                        [ngClass]="{'ng-invalid ng-dirty' : !tramiteCompleto && !densidadSeleccionada()}"></p-dropdown>
                            <small style="color:red" class="ng-dirty ng-invalid"
                                   *ngIf="!tramiteCompleto && !densidadSeleccionada()"><b>Favor
                                seleccione el grado de densidad</b></small>
                        </div>
                        <div class="field col-12 md:col-3">
                            <p-dropdown [readonly]="densidadSeleccionada()==null?true:false" #dropPrueba
                                        [ngModel]="urbanizacionSeleccionada" (onChange)="setUrbanizacion($event.value)"
                                        id="urbanizacion" [options]="listaUrbanizacion" optionLabel="descripcion"
                                        [showClear]="true" placeholder="Grado de Urbanización *" [required]="true"
                                        [ngClass]="{'ng-invalid ng-dirty' : !tramiteCompleto &&localizacionSeleccionada()?.id!='4'}"></p-dropdown>
                            <small style="color:red" class="ng-dirty ng-invalid"
                                   *ngIf="!tramiteCompleto && !urbanizacionSeleccionada && localizacionSeleccionada()?.id!='4'"><b>Favor
                                seleccione el entorno del terreno</b></small>
                        </div>
                    </div>
                    <div class="text-900 font-semibold text-xl">Etapas del proyecto</div>
                    <div class="p-fluid p-formgrid grid mt-2">
                        <div class="field col-12 md:col-3">
                            <p-inputNumber placeholder="Etapa" [(ngModel)]="cantidadEtapa"
                                           pTooltip="Numero de etapa"
                                           [required]="true" [useGrouping]="false" [min]="1"></p-inputNumber>
                        </div>
                        <div class="field col-12 md:col-3">
                            <p-inputNumber placeholder="Meses*" [(ngModel)]="numeroMes" mode="decimal"
                                           pTooltip="Ingresar los meses"
                                           [required]="true" [useGrouping]="false" [min]="1" [max]="12">
                            </p-inputNumber>
                        </div>
                        <div class="field col-12 md:col-3">
                            <p-button (onClick)="agregarEtapa()" class="ml-3" icon="pi pi-plus"
                                      pTooltip="Agregar etapa"></p-button>
                        </div>
                    </div>
                    <div class="text-900 font-semibold text-lg -mt-5 mb-5">
                        <small style="color:red" class="ng-dirty ng-invalid" *ngIf="errorEtapas"><b>Favor ingresar una
                            cantidad de etapa o de meses correcta</b>
                        </small>
                    </div>
                    <div>
                        <p-table #dtEtapasProyecto [style]="{'border': !tramiteCompleto && listaEtapas.length==0?'1px solid red':''}"
                                 columnResizeMode="expand" [value]="listaEtapas" [paginator]="true"
                                 styleClass="p-datatable-gridlines" [rows]="5" [showCurrentPageReport]="true"
                                 [tableStyle]="{ 'min-width': '50rem' }"
                                 currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} etapas del proyecto"
                                 [rowsPerPageOptions]="[5, 10, 25, 50]">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th style="width:25%">Etapa</th>
                                    <th style="width:25%">Meses</th>
                                    <th style="width:25%">Operación</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-etapas let-index="rowIndex">
                                <tr>
                                    <td>
                                        {{ etapas.numeroEtapa }}
                                    </td>
                                    <td>
                                        {{ etapas.cantidadMeses }}
                                    </td>
                                    <td>
                                        <p-button pTooltip="Eliminar etapa" icon="pi pi-trash"
                                                  styleClass="p-button-rounded p-button-danger p-button-text"
                                                  (click)="eliminarEtapas(index)"></p-button>
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                        <small style="color:red" class="ng-dirty ng-invalid"
                               *ngIf="!tramiteCompleto && listaEtapas.length==0"><b>Favor ingresar una o más etapas </b>
                        </small>
                    </div>
                </ng-container>
                <ng-template #elseForm>
                    <div class="text-900 font-semibold text-xl">Unidades habitacionales</div>
                    <div class="p-fluid p-formgrid grid mt-2">
                        <div class="field col-12 md:col-3">
                            <p-inputNumber placeholder="Cantidad unidades" [(ngModel)]="cantidadUnidades" mode="decimal"
                                           [ngClass]="{'ng-invalid ng-dirty' : !tramiteCompleto && cantidadUnidades==null}"
                                           [min]="1" [required]="true" [useGrouping]="false"
                                           pTooltip="Cantida unidades"></p-inputNumber>
                        </div>
                        <div class="field col-12 md:col-3">
                            <p-dropdown [(ngModel)]="nivelSeleccionado" #nivelDrop [options]="listaNivel"
                                        [required]="true"
                                        [ngClass]="{'ng-invalid ng-dirty' : !tramiteCompleto && !nivelSeleccionado}"
                                        optionLabel="descripcion" [showClear]="true" placeholder="Seleccione Nivel *"
                            ></p-dropdown>
                        </div>
                        <div class="field col-12 md:col-3">
                            <p-button (click)="agregarUnidadHabitacional()" class="ml-3" icon="pi pi-plus"
                                      pTooltip="Agregar unidades"></p-button>
                        </div>
                    </div>
                    <div class="text-900 font-semibold text-lg -mt-5 mb-5">
                        <small style="color:red" class="ng-dirty ng-invalid" *ngIf="errorUnidades"><b>Favor ingresar una
                            cantidad de unidades correcta y seleccionar el nivel</b>
                        </small>
                    </div>
                    <div>
                        <p-table
                            #dtUnidadesHabitacionales [style]="{'border': !tramiteCompleto && unidadesHabitacionales.length==0?'1px solid red':''}"
                            columnResizeMode="expand" [value]="unidadesHabitacionales" [paginator]="true"
                            styleClass="p-datatable-gridlines" [rows]="5" [showCurrentPageReport]="true"
                            [tableStyle]="{ 'min-width': '50rem' }"
                            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} unidades habitacionales"
                            [rowsPerPageOptions]="[5, 10, 25, 50]">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th style="width:25%">Cantidad unidades</th>
                                    <th style="width:25%">Nivel</th>
                                    <th style="width:25%">Operación</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-niveles let-index="rowIndex">
                                <tr>
                                    <td>
                                        {{ niveles.cantidad }}
                                    </td>
                                    <td>
                                        {{ niveles.descripcion }}
                                    </td>
                                    <td>
                                        <p-button pTooltip="Eliminar nivel" icon="pi pi-trash"
                                                  styleClass="p-button-rounded p-button-danger p-button-text"
                                                  (click)="eliminarUnidadHabitacional(index)"></p-button>
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                        <small style="color:red" class="ng-dirty ng-invalid"
                               *ngIf="!tramiteCompleto && unidadesHabitacionales.length==0"><b>Favor ingresar una o más
                            unidades
                            habitacionales</b>
                        </small>
                    </div>
                </ng-template>
            </div>
        </p-panel>
        <div class="mt-5">

            <p-accordion [activeIndex]="0">
                <p-accordionTab header="Documentos y formularios" class="line-height-3 m-0">
                    <solicitud-requisitos [requisitos]="tramiteService.requisitosFormularios()"
                                          [idProyecto]="this.idProyecto"
                                          [idSolicitud]="this.selected!.idSolicitud?.toString()!"
                                          [idTramite]="this.idTramite"
                                          [datosCargados]="tramiteService.datosCargados"
                                          (onEventEmitterSelected)="onReceiveTramite($event)"
                    ></solicitud-requisitos>

                </p-accordionTab>
            </p-accordion>
        </div>
    </div>

    <div class="p-fluid p-formgrid grid mt-2">
        <div class="field col-12 md:col-9">
            <ul class="list-none m-0 w-full">
                <li class="flex justify-content-between surface-border py-3">
                    <span class="text-900 text-4xl font-medium">Total a cancelar por trámite: $ <b>{{ tarifa }}</b>
                    </span>
                </li>
            </ul>
        </div>
        <div class="field col-12 md:col-3">
            <div class="flex justify-content-end gap-2">
                <p-button class="ml-3" icon="pi pi-calculator" (click)="onChangeCalcularTarifa()"
                        styleClass="p-button-icon p-button-info p-button-lg p-button-rounded w-full h-full"
                        pTooltip="Calcular tarifa" tooltipPosition="top"></p-button>
                <p-button (click)="completarTramite()" [rounded]="true"
                        icon="pi pi pi-cart-plus"
                        iconPos="right"
                        styleClass="p-button-icon p-button-info text-xl h-full"
                        [disabled]="validacionBotonCompletarTramite() || isLoading()" label="Proceder a pagar"></p-button>
            </div>
        </div>
    </div>
    <div class="p-fluid grid" *ngIf="tramiteService.textTarifa!=''">
        <div class="col-12 align-self-center">
            <small class="text-gray-600">*{{ tramiteService.textTarifa }}</small>
        </div>
    </div>
</p-card>
